import React, { useState, useEffect } from "react";
import FadedBackgroundLayout from '../layouts/FadedBackgroundLayout'
//import Time from "../../utils/time";
//import Link from "next/link";
//import { useRouter } from "next/router";
// import { useHistory } from "react-router-dom"; // Uncomment if you want to use navigation


const Login = () => {
  // const history = useHistory(); // Uncomment if you want to use navigation
  //const router = useRouter();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [passwordError, setPasswordError] = useState("")
  const [emailError, setEmailError] = useState("")

  useEffect(() => {
    if (error.length > 0) {
      console.log(error);
    }
  }, [error]);

  const handleEmail = (e) => {
    setEmail(e.target.value);
  };

  const handlePassword = (e) => {
    setPassword(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if ("" === email) {
      setEmailError("Please enter your email")
      return
  }

  if (!/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(email)) {
      setEmailError("Please enter a valid email")
      return
  }

    if ("" === password) {
      setPasswordError("Please enter a password")
      return
  }

  if (password.length < 7) {
      setPasswordError("The password must be 8 characters or longer")
      return
  }

    try {
      //const response = await fetch('https://syntaxmap-back.onrender.com/user/login', {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/user/login`, {
        method: 'POST',
        body: JSON.stringify({
          user_password: password,
          user_email_address: email,
        }),
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
      });

      if (!response.ok) {
        const data = await response.json();
        throw new Error(data.message);
      }

      const data = await response.json();
      localStorage.setItem('jstoken', data.jwt.token);

      const date = new Date();
      const formattedDate = `${date.getFullYear()}-${
        date.getMonth() + 1 < 10 ? '0' : ''
      }${date.getMonth() + 1}-${date.getDate()}`;

      let session = data.last_session;

      if (!session || session.split('_')[0] !== formattedDate) {
        session = `${formattedDate}_1`;
      } else {
        const nextSession = parseInt(session.split('_')[1]) + 1;
        session = `${formattedDate}_${nextSession}`;
      }

      localStorage.setItem('session', session);
      //window.location.replace("https://syntax-map-new-web.vercel.app/tensemap");
      window.location.replace(process.env.REACT_APP_TENSEMAP_URL);
    } catch (err) {
      setError(err.message);
    }
  };


  return (
    <FadedBackgroundLayout>
    <section
      id="banner-2"
      className="bg-02 wide-60 banner-section"
      style={{ marginTop: "100px" , height: "100vh", overflow: "auto" }}
    >
      <div className="container">
  <div className="row d-flex align-items-center">
    {/* BANNER TEXT */}
    <div className="col-md-7">
    <div className="text-dark"> {/* Bootstrap class for dark text color */}
  {/* Title */}
  <h1 className="display-4 font-weight-bold my-4">
    Welcome to Syntax Map
  </h1>
  <p className="lead">
    More than <strong>1000</strong> questions to learn and practise English.
  </p>
</div>
    </div>
    {/* REGISTER FORM */}
    <div className="col-md-5">
      <div id="register-form">
        <form name="registerForm" className="register-form" onSubmit={handleSubmit}>
          {/* Form Input */}
          <div className="form-group mb-3"> {/* Bootstrap form group with bottom margin */}
            <label htmlFor="inputEmail" className="form-label">Your Email*</label> {/* Added label for accessibility */}
            <input
              id="inputEmail"
              type="email"
              value={email}
              autoComplete="off"
              className="form-control"
              placeholder="Enter Your Email*"
              required
              onChange={handleEmail}
            />
            <label style={{color: 'red', fontSize: '12px'}}>{emailError}</label>
          </div>
          {/* Form Input */}
          <div className="form-group mb-3">
            <label htmlFor="inputPassword" className="form-label">Password*</label>
            <input
              id="inputPassword"
              type="password"
              value={password}
              onChange={handlePassword}
              autoComplete="off"
              className="form-control"
              placeholder="Enter Your Password*"
            />
            <label style={{color: 'red', fontSize: '12px'}}>{passwordError}</label>
          </div>
          {/* Form Button */}
          <div className="d-grid gap-2">
            <button type="submit" className="btn btn-primary btn-lg"> {/* Bootstrap button with large size */}
              Sign In
            </button>
          </div>
          <div className="text-center mt-4"> {/* Centered text with top margin */}
            <p>If you have not registered, please register instead</p>
            <a href="registration" className="btn btn-outline-danger"  style={{color: '#dc3545', fontWeight: 'bold', fontSize: '18px'}}> {/* Danger outline button */}
            Register
            </a>
          </div>
          {/* Form Message */}
          <div className="register-form-msg text-center mt-3">
            <span className="loading" />
          </div>
        </form>
        {error && <div className="alert alert-danger mt-3" role="alert">{error}</div>} {/* Bootstrap alert for error */}
      </div>
    </div>
    {/* END REGISTER FORM */}
  </div>
</div>

      {/* End container */}
    </section>
  </FadedBackgroundLayout>
  );
};

export default Login;